<template>
  <div class="home-page">
    <recycle-header
      @help="showQrcodeDialog"
    />
    <div class="body">
      <recycle-banner
        @qrcode="showQrcodeDialog"
      />
      <recycle-achievement />
      <recycle-way />
      <recycle-class />
      <recycle-advantage />
      <recycle-partner />
    </div>
    <recycle-footer />
    <footer-mask
      :show="maskVisible"
      @close="closeMask"
    />
    <qrcode-dialog
      v-model="qrcodeVisible"
      :data="selectClient"
    />
    <contact-service />
  </div>
</template>

<script>
import RecycleHeader from './components/recycle-header';
import RecycleBanner from './components/recycle-banner';
import RecycleAchievement from './components/recycle-achievement';
import RecycleWay from './components/recycle-way';
import RecycleClass from './components/recycle-class';
import RecycleAdvantage from './components/recycle-advantage';
import RecyclePartner from './components/recycle-partner';
import RecycleFooter from './components/recycle-footer';
import QrcodeDialog from './components/qrcode-dialog';
import ContactService from './components/contact-service';
import FooterMask from './components/footer-mask';

export default {
  components: {
    RecycleHeader,
    RecycleBanner,
    RecycleAchievement,
    RecycleWay,
    RecycleClass,
    RecycleAdvantage,
    RecyclePartner,
    RecycleFooter,
    QrcodeDialog,
    ContactService,
    FooterMask
  },
  data () {
    return {
      selectClient: {},
      qrcodeVisible: false,
      maskVisible: false
    };
  },
  methods: {
    addScrollEvent () {
      window.addEventListener('scroll', this.scrollHandle);
    },
    scrollHandle () {
      // 可视区域高度
      const clientHeight = document.documentElement.clientHeight;
      // 滚动条顶部到页面顶部的距离
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      // 整个页面高度
      const scrollHeight = document.documentElement.scrollHeight;
      // 显示浮窗范围
      const showMaskRange = scrollTop > 400 && (scrollTop + clientHeight < scrollHeight - 222);
      if (showMaskRange && !this.maskVisible) {
        this.maskVisible = true;
      } else if (!showMaskRange && this.maskVisible) {
        this.maskVisible = false;
      }
    },
    removeScrollEvent () {
      window.removeEventListener('scroll', this.scrollHandle);
    },
    showQrcodeDialog (item) {
      this.selectClient = item;
      this.qrcodeVisible = true;
    },
    closeMask () {
      this.maskVisible = false;
      this.removeScrollEvent();
    }
  },
  destroyed () {
    this.removeScrollEvent();
  },
  mounted () {
    this.addScrollEvent();
  }
};
</script>

<style scoped>
@import './index.scss';
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/welcome/index.vue